
import React from 'react'
import { CaptionText } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { screenSmall } from 'components/utils/screen-sizes'

const cardImageStyle = (src, cssProp) => css`
  display: block;
  margin: 0.75rem auto;
  width: 21.25rem;
  height: 13.40625rem;
  border-radius: 0.625rem;
  background-image: url('${src}');
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  @media (max-width: ${screenSmall}) {
    width: 15.625rem;
    height: 9.813rem;
  }
  ${cssProp}
`

const cardImageSlantedStyle = css`
  transform: rotate(-7.62deg);
`

const cardImageShadow = css`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    height: 80%;
    width: 15rem;
    left: 0;
    top: 3rem;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 0.625rem;
    transform: matrix(1, -0.05, 0.05, 1, 0, 0);
    background: rgba(16, 16, 16, 0.2);
    filter: blur(20px);
  }
`

const cardNumberSuffixCss = css`
  position: absolute;
  color: #fff !important;
  left: 1rem;
  bottom: 1rem;
`

function CardImage({ id = 'card-image', src, alt, loading, cardNumberSuffix, cssProp }) {
  // Using div with background image to avoid flashing the page slides in
  return (
    <div id={id} css={loading && cardImageShadow}>
      <div
        role="img"
        aria-label={alt}
        css={css([cardImageStyle(src, cssProp), loading && cardImageSlantedStyle])}
      >
        {
          cardNumberSuffix && 
          <CaptionText strong css={cardNumberSuffixCss}>
            {cardNumberSuffix}
          </CaptionText>
        }
      </div>
    </div>
  )
}

CardImage.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  loading: PropTypes.bool,
  cardNumberSuffix: PropTypes.string,
  cssProp: PropTypes.object,
}

export default CardImage
